<div class="pages-body login-page p-d-flex p-flex-column">

    <p-messages [value]="msgs"></p-messages>
    <div class="p-as-center p-mt-auto p-mb-auto">
        
        <div class="pages-panel card p-d-flex p-flex-column">
              <p-panel #pnl header="{{ 'usuario.tituloalterar' | translate }}">
                <b>Escolha uma nova senha, lembre-se para uma senha 
                <br>forte ela tem que ter ao mesmo tempo:</b>
                <ul>
                    <li>no minimo 8 caracteres</li>
                    <li>uma ou mais letras mai&uacute;sculas <b>(A-Z)</b></li>
                    <li>uma ou mais letras minusculas <b>(a-z)</b></li>
                    <li>um ou mais n&uacute;meros <b>(0-9)</b></li>
                    <li>um ou mais caracteres especias <b>(#!*_-@)</b></li>
                </ul>
                EX:(XXxx00##)
            </p-panel>
            <br/>
            <h4>{{ 'usuario.criarnovasenha' | translate }}</h4>
            <div class="input-panel p-d-flex p-flex-column p-px-3">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="password" id="password" pInputText [(ngModel)]="updatePassword.oldPassword" required autofocus>
                        <label for="password">{{ 'usuario.senhaantiga' | translate }}</label>
                    </span>
                </div>

                <div class="p-inputgroup p-mt-3 p-mb-10">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="password" id="newPassword" pInputText [(ngModel)]="updatePassword.newPassword" required autofocus>
                        <label for="newPassword">{{ 'usuario.novasenha' | translate }}</label>
                    </span>
				</div>

				<div class="p-inputgroup p-mt-3 p-mb-10">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="password" id="confNewPassword" pInputText [(ngModel)]="updatePassword.confNewPassword" required autofocus>
                        <label for="confNewPassword">{{ 'usuario.confirmarNova' | translate }}</label>
                    </span>
                </div>

            </div>

            <br/>
            <p-button class="login-button p-mb-10 p-px-3" label="{{ 'label.alterar' | translate }}" (click)="update()"></p-button>

        </div>
    </div>
</div>
